import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseDeleteTagsMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function useDeleteTagsMutation({ onSuccess, onError, impersonationContext }: UseDeleteTagsMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (tagNames: string[]) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tag/tags',
				}),
				'DELETE',
				tagNames
			);
		},
		onSuccess,
		onError,
	});
}
